import Components from './../Component';
import ComponentFactory from './../ComponentFactory';

export default class Menu extends Components {

  constructor($) {
    super($);
    this.menuOpen = false;
    this.level = 0;
    this.liOpen = false;
    this.openTrack = false;
  }

  init(index, element) {
    this.$(element).find('li.has-submenu').each(function (i, li) {
      this.$(li).find(' > a').attr('href', '#');
      this.$(li).find(' > a').on('click', function (e) {
        e.preventDefault();
        if (ComponentFactory.currentBreakpoint == 'mobile' || ComponentFactory.currentBreakpoint == 'tablet') {
          this.openLi(element, li);
        } else {
          if (this.$(li).hasClass('open')) {
            this.closeMenu(element);
          } else {
            this.openLi(element, li);
          }
        }


      }.bind(this));
    }.bind(this));

    this.$(element).find('li.has-submenu > a').each(function (index, a) {
      this.$(a).attr('href', '#');
      this.$(a).on('click', function (e) {
        e.preventDefault();
      });
    }.bind(this));

    this.$(document).on('click', function (e) {

      if (ComponentFactory.currentBreakpoint == 'mobile') {
        //Do nothing
      } else if (ComponentFactory.currentBreakpoint == 'tablet') {
        if (!this.$(e.target).parents('.header-navigation').length && this.menuOpen) {
          this.closeMenu(element);
        }
      } else {
        if (!this.$(e.target).parents('.menu-wrapper').length && this.menuOpen) {
          this.closeMenu(element);
        }
      }


    }.bind(this));

    this.$('#menuToggle').on('click', function (e) {
      e.preventDefault();
      this.toggleMenu(element);
    }.bind(this));

    this.$('.has-sublinks > a').on('click', function (e) {
      if (ComponentFactory.currentBreakpoint == 'mobile' || ComponentFactory.currentBreakpoint == 'tablet') {
        e.preventDefault();
        this.$('.has-sublinks').removeClass('open');
        this.$(e.currentTarget).closest('.has-sublinks').addClass('open');
        this.setLevel(2);
      }
    }.bind(this));

    this.$(element).find('.back').on('click', function (e) {
      this.setLevel(this.level - 1);
    }.bind(this));
  }

  resetLevel() {
    this.level = 0;
    this.$('.menu-wrapper').removeClass('level-1');
    this.$('.menu-wrapper').removeClass('level-2');

    var h = 0;
    this.$('.menu-container').children().each(function (index, element) {
      h += this.$(element).height();
    }.bind(this));

    if (ComponentFactory.currentBreakpoint != 'mobile' && ComponentFactory.currentBreakpoint != 'tablet') {
      this.$('.menu-container').height('auto');
    } else {
      this.$('.menu-container').height(h);
    }

  }

  setLevel(level) {
    this.resetLevel();
    if (level > 0) {
      this.level = level;
      this.$('.menu-wrapper').addClass('level-' + level);
    }

    if (ComponentFactory.currentBreakpoint != 'mobile' && ComponentFactory.currentBreakpoint != 'tablet') {
      this.$('.menu-container').height('auto');
    } else {
      if (level == 1) {
        this.$('.menu-container').height(this.$('.has-submenu.open > .submenu > .submenu-links > ul').height() + 140);
      }
      if (level == 2) {
        this.$('.menu-container').height(this.$('.has-submenu.open > .submenu > .submenu-links > ul .has-sublinks.open > ul').height() + 140);
      }
    }


  }

  openLi(element, li) {

    setTimeout(function(){
      this.$(li).find('> a').attr('aria-expanded','true');
    }.bind(this),1);


    this.$('.menu-wrapper').addClass('menu-open');
    this.closeLi(element);
    this.$(li).addClass('open');
    this.openMenu(element);
    this.setLevel(1);
  }

  closeLi(element) {
    this.$(element).find('li.has-submenu').find('> a').attr('aria-expanded','false');
    this.$(element).find('li.has-submenu').removeClass('open');
  }

  toggleMenu(element) {
    if (!this.menuOpen) {
      this.openMenu(element);
    } else {
      this.closeMenu(element);
    }
  }

  openMenu() {
    setTimeout(function () {
      this.menuOpen = true;
    }.bind(this), 100);

    if (!this.openTrack){
      this.openTrack = true;
      //Check if _paq is defined

      if (typeof _paq !== 'undefined'){
        _paq.push(['trackEvent','Home', 'HomeClick', "OpenMenu"]);
      }
    }

    this.$('.overlay').addClass('show');
    this.$('body').addClass('menu-open');
    this.$('#menuToggle').addClass('open');
    this.$('.mobile-form').addClass('open');
    this.$('.menu-wrapper').addClass('menu-open');

    if (ComponentFactory.currentBreakpoint != 'mobile' && ComponentFactory.currentBreakpoint != 'tablet') {
      this.$('.has-submenu.open .submenu-links .has-sublinks:first > a').focus();
    }

  }

  closeMenu(element) {
    this.menuOpen = false;
    this.$('.overlay').removeClass('show');
    this.$('body').removeClass('menu-open');
    this.$('#menuToggle').removeClass('open');
    this.$('.mobile-form').removeClass('open');
    this.$('.menu-wrapper').removeClass('menu-open');

    if (ComponentFactory.currentBreakpoint != 'mobile' && ComponentFactory.currentBreakpoint != 'tablet') {
      this.closeLi(element);
      this.resetLevel();
    } else {
      setTimeout(function () {
        this.closeLi(element);
        this.resetLevel();
      }.bind(this), 300);
    }
  }

  breakpoint(index, element, breakpoint) {
    this.closeMenu(element);
  }

  resize(index, element) {
    /*STICKY*/
    this.$('.header-navigation').unstick();
    if (ComponentFactory.currentBreakpoint != 'mobile' && ComponentFactory.currentBreakpoint != 'tablet') {
      this.$('.header-navigation').sticky({
        topSpacing: -70
      }).bind(this);
    }
  }

}
